import axios from "axios";

export const getServerTime = async () => {
  return new Date();
};
